import request from 'services/request';
const serviceURL = '/Catalogs/Api/v1/Clients/Detail/';

export async function getOneClient({ cancelToken, clientId }) {
  return request(`${serviceURL}${clientId}`, {
    method: 'GET',
    cancelToken,
  });
}
